import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginPassword: "",
  },
  mutations: {
    setPassword(state, payload) {
      sessionStorage.setItem("loginPassword", payload);
      state.loginPassword = payload;
    },
  },
  actions: {
    actionSetPassword({ commit }, payload) {
      commit("setPassword", payload);
    },
    actionLogout({ commit }) {
      commit("setPassword", "");
      sessionStorage.removeItem("loginPassword");
    },
  },
  getters: {
    loginPassword: (state) => {
      return state.loginPassword;
    },
  },
  modules: {},
});
